module.exports = __webpack_public_path__ + "static/img/email.f96a80c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/email.svg
// module id = suMk
// module chunks = 1